import { Alert, TextField } from '@mui/material';
import { useContext, useMemo } from 'react';

import { UsersContext } from '@/Contexts/UsersContext';
import { UserType } from '@/models/User';

import { ReviewerInfo } from '../utils/ReviewerModalTypes';
import { Email } from '@/components/common/text_input/Email';

export function NewReviewerForm({
  reviewerInfo,
  onChange,
  applicantEmails,
  reviewerEmails,
}: {
  reviewerInfo: ReviewerInfo;
  onChange: (patch: Partial<ReviewerInfo>) => void;
  applicantEmails: string[]; // lowercased
  reviewerEmails: string[]; // lowercased
}) {
  const { userType } = useContext(UsersContext);
  const email = (reviewerInfo.email || '').toLowerCase();

  const { showError, showReassign } = useMemo(() => {
    const isApplicant = applicantEmails.includes(email);
    const isReviewer = reviewerEmails.includes(email);
    const isAdfEmail = email.includes('arborday.org');

    const showError =
      email !== '' && ((isApplicant && userType !== UserType.Adf) || isReviewer || isAdfEmail);

    const showReassign = isApplicant && userType === UserType.Adf;

    return { showError, showReassign };
  }, [email, applicantEmails, reviewerEmails, userType]);

  return (
    <>
      <Email
        label='Email'
        required
        value={reviewerInfo.email}
        onChange={(e) => onChange({ email: e.target.value.toLowerCase() })}
        error={showError}
        fullWidth
        sx={{ mt: 2 }}
      />

      {showError && (
        <Alert severity='error' sx={{ mt: 1 }}>
          Please enter an email that is not an applicant and not an Arbor Day Foundation address.
        </Alert>
      )}

      {showReassign && (
        <Alert severity='warning' sx={{ mt: 1 }}>
          This user is currently an applicant. Submitting will reassign them as a reviewer.
        </Alert>
      )}

      <TextField
        label='First Name'
        required
        value={reviewerInfo.firstName}
        onChange={(e) => onChange({ firstName: e.target.value })}
        error={!reviewerInfo.firstName}
        fullWidth
        sx={{ mt: 2 }}
      />

      <TextField
        label='Last Name'
        required
        value={reviewerInfo.lastName}
        onChange={(e) => onChange({ lastName: e.target.value })}
        error={!reviewerInfo.lastName}
        fullWidth
        sx={{ mt: 2 }}
      />
    </>
  );
}
